import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import PublicHomePage from './PublicHomePage';

export const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { isAuthenticated, loading } = useAuth();

  const redirectTo = searchParams.get('redirect') || '/';

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <PublicHomePage initialAuthMode="login" />;
};

export default Login;
